/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { buildGA4EcommerceItem } from '@/data/events/data/gtm/EcommerceItem';
import {
	getAttributeValue,
	getPriceType,
	getProductRibbons,
	getProductSizes,
} from '@/data/events/data/gtm/productAttributes';
import { GTMCartViewPayload } from '@/data/types/GTM';

export const getGTMCartViewEventData = async (payload: GTMCartViewPayload) => {
	const { cart: _cart, storeName, orgName, orgId, orderItemListRows = [] } = payload;
	const { grandTotal = 0, grandTotalCurrency = '' } = _cart;
	const hcl_account = orgId ? orgName : null;
	const cart = { grandTotal, grandTotalCurrency };

	const products = orderItemListRows.map((row) => {
		const attributes = row.details.attributes;
		const product = row.product;
		// `product` es el SKU hijo y NO trae items/ribbons; viven en el padre.
		const parentProduct = row.parentProduct;
		const productPrice = product?.productPrice;

		return buildGA4EcommerceItem({
			partNumber: row.details?.partNumber || parentProduct?.partNumber,
			name: product?.name,
			type: product?.type,
			affiliation: 'Dportenis',
			brand: getAttributeValue(attributes, 'Marca'),
			genre: getAttributeValue(attributes, 'Genero'),
			family: getAttributeValue(attributes, 'Familia'),
			use: getAttributeValue(attributes, 'Uso'),
			size: getAttributeValue(attributes, 'Talla'),
			color: getAttributeValue(attributes, 'Color1'),
			sizes: getProductSizes(parentProduct),
			priceType: getPriceType(productPrice),
			ribbons: getProductRibbons(parentProduct),
			productPrice,
			price: Number(row.orderItemListRow.price.orderItemPrice),
			currency: 'MXN',
			quantity: 1,
		});
	});

	return {
		cart,
		products,
		hcl_account,
		marketplaceStore: storeName,
	};
};
